<template>
  <div class="QueryContractItem mt_5">
    <div class="QueryContractItem__head">
      <div class="mr_6">NO.{{ NO }}</div>
      <div class="QueryContractItem__head__date mr_6">
        建立日期：{{ contractData.createROCdate }}
      </div>
      <div class="QueryContractItem__head__insured mr_6">
        要保人：
        <!-- hover身分證、生日 -->
        <Tooltip v-if="familyid"
          position="top"
          :id="contractData.insurer_id.indexOf('~') > -1 ? '' : contractData.insurer_id"
          :birthday="formatDate(contractData.insurer_birthday)"
        >
          <a
            v-on:click="routeToCustDetailWithCustomStatusCheck(contractData.insurer_id)"
            class="link text-underline">
            {{ truncate(contractData.insurer_name, 8) }}
          </a>
        </Tooltip>
        <span v-else>{{ truncate(contractData.insurer_name, 8) }}</span>
      </div>
      <div class="d-flex justify-content-end">
        <Avatar
          class="mr-2"
          :gender="Number(contractData.insurer_gender)"
          :size="20"
          :height="20"
        />
        <strong>{{ contractData.insurer_age }}歲</strong>
      </div>
      <div class="d-flex float-right ml-auto justify-content-end">
        <button
          class="btn btn-default btn-md mr_2 text-nowrap"
          @click="featuresHandler('print')"
          style="width: 117px"
        >
          列印建議書
        </button>
        <button
          class="btn btn-default btn-md mr_2 text-nowrap"
          @click="featuresHandler('importMobile')"
          v-if="is_crm == '1' && !this.$store.getters.IsDirectMarketingUser"
          :disabled="!contractData"
          style="width: 117px"
        >
          匯入行動投保
        </button>
        <div class="dropdown float-right ml-auto">
          <button
            class="btn btn-default btn-md mr_0 text-nowrap"
            aria-expanded="false"
            aria-haspopup="true"
            data-toggle="dropdown"
          >
            更多···
          </button>
          <div class="dropdown-menu dropdown-menu-right">
            <a
              @click="featuresHandler('edit')"
              role="button"
              class="dropdown-item text-green text-underline"
              >修改建議書</a
            >
            <a
              @click="featuresHandler('performaceTable')"
              role="button"
              class="dropdown-item text-green text-underline"
              >業績換算</a
            >
            <a
              v-if="insured_id != ''"
              @click="featuresHandler('eReview')"
              role="button"
              class="dropdown-item text-green text-underline"
              >E檢核</a
            >
            <a
              v-if="is_crm == '1'"
              @click="featuresHandler('importInsurance')"
              role="button"
              class="dropdown-item text-green text-underline"
              >匯入保單健檢</a
            >
            <a
              @click="
                confirmDelete();
                updateClickDate(
                  nowSelectProposal.prod_idx,
                  nowSelectProposal.prod_type,
                );
              "
              role="button"
              class="dropdown-item text-green text-underline"
              >刪除建議書</a
            >
          </div>
        </div>
      </div>
    </div>
    <div
      class="QueryContractItem__mc"
      v-for="(MC, index) in contractData.mc_prod_list"
      :key="'mc_' + index"
    >
      <div class="QueryContractItem__mc__index">
        <div>建議{{ index + 1 }}</div>
        <div>繳別：{{ getPay_freq_nm(MC.pay_freq) }}</div>
      </div>
      <div class="QueryContractItem__mc__title">
        <div>商品名稱</div>
        <div>商品<br />代號</div>
        <div>繳費<br />年期</div>
        <div>被保險人</div>
        <div class="justify-content-end text-right">保額/計畫別</div>
        <div>應繳保費<br />(折減前)</div>
        <div>商品<br />狀態</div>
      </div>
      <!-- 主約 -->
      <div class="QueryContractItem__mc__info">
        <div class="justify-content-start text-left">
          {{ MC.prod_name
          }}<template v-if="MC.job_cat != ''">{{
            `(職業類別:${MC.job_cat}類)`
          }}</template>
        </div>
        <div>{{ MC.prod_id }}</div>
        <div>
          {{
            MC.pay_period_matur == "0" ||
            MC.renew_type == "3" ||
            MC.renew_type == "4"
              ? MC.pay_prd
              : MC.pay_prd - contractData.insured_age
          }}{{ MC.pay_prd != "" ? "年" : "" }}
        </div>
        <div class="d-flex flex-column">
          <div>
            <!-- hover身分證、生日 -->
            <Tooltip v-if="familyid"
              position="top"
              :id="contractData.insured_id.indexOf('~') > -1 ? '' : contractData.insured_id"
              :birthday="formatDate(contractData.insured_birthday)"
            >
              <a
                v-on:click="routeToCustDetailWithCustomStatusCheck(contractData.insured_id)"
                class="link text-underline">
                {{ truncate(contractData.insured_name) }}
              </a>
            </Tooltip>
            <span v-else>{{ truncate(contractData.insured_name) }}</span>
          </div>
          <div class="fz_13">
            ({{ contractData.insured_gender == "1" ? "男" : "女" }},
            {{ contractData.insured_age }}歲)
          </div>
        </div>
        <div class="justify-content-end">
          {{ formatMethods(MC.amt) }}{{ MC.amt != "" ? MC.amt_unit_nm : "" }}
        </div>
        <div class="justify-content-end">
          {{ formatMethods(MC.premium)
          }}{{ MC.premium != "" ? MC.curr_nm : "" }}
        </div>
        <div class="stop_sale">{{ MC.stop_sale == "1" ? "停售" : "" }}</div>
      </div>
      <!-- 附約 -->
      <div
        class="QueryContractItem__mc__SC"
        v-for="(SC, index) in MC.sc_prod_list"
        :key="'sc_' + index"
      >
        <div class="justify-content-start text-left">
          └ {{ SC.prod_name
          }}<template v-if="SC.job_cat != ''">{{
            `(職業類別:${SC.job_cat}類)`
          }}</template>
        </div>
        <div>{{ SC.prod_id }}</div>
        <div>{{ SC.pay_prd }}{{ SC.pay_prd != "" ? "年" : "" }}</div>
        <div class="d-flex flex-column">
          <div>
            <!-- hover身分證、生日 -->
            <Tooltip v-if="familyid"
              position="top"
              :id="SC.insured_id.indexOf('~') > -1 ? '' : SC.insured_id"
              :birthday="formatDate(SC.insured_birthday)"
            >
              <a
                v-on:click="routeToCustDetailWithCustomStatusCheck(SC.insured_id)"
                class="link text-underline">
                {{ truncate(SC.insured_name) }}
              </a>
            </Tooltip>
            <span v-else>{{ truncate(SC.insured_name) }}</span>
          </div>
          <div class="fz_13">
            ({{ SC.insured_gender == "1" ? "男" : "女" }},
            {{ SC.insured_age }}歲)
          </div>
        </div>
        <div class="justify-content-end">
          {{ formatMethods(SC.amt) }}{{ SC.amt != "" ? SC.amt_unit_nm : "" }}
        </div>
        <div class="justify-content-end">
          {{ formatMethods(SC.premium)
          }}{{ SC.premium != "" ? SC.curr_nm : "" }}
        </div>
        <div class="stop_sale">{{ SC.stop_sale == "1" ? "停售" : "" }}</div>
      </div>
      <!-- 應繳保費合計(折減前) -->
      <div class="QueryContractItem__totalBeforeDiscount">
        <div>
          {{ getPay_freq_nm(MC.pay_freq).split("繳")[0] }}應繳保費(保費折減前)
          合計:
        </div>
        <div>
          {{ formatMethods(getTotal_mc(MC))
          }}{{ MC.premium != "" ? MC.curr_nm : "" }}
        </div>
      </div>
    </div>
    <ChangePopup
      :crmMapList="crmMapList"
      :oldCrmMapList="oldCrmMapList"
      v-if="changePopupHandler"
      @cancel="changePopupHandler = false"
      @finish="toHandler"
    />
  </div>
</template>

<script>
import mf_Mixin from "@/desktop/views/mf/mixin";
import Avatar from "@/desktop/components/Avatar";
import moment from "moment";
import ChangePopup from "@/desktop/views/mf/components/2.Query/2-3-1.QueryDetail/ChangePopup.vue";
import Tooltip from "@/desktop/components/ToolTip";
export default {
  mixins: [mf_Mixin],
  props: ["contractData", "selected", "NO", "selectedMode"],
  components: { Avatar, ChangePopup, Tooltip },
  data() {
    return {
      moreOpen: false,

      changePopupHandler: false,
    };
  },
  computed: {
    //是否含停售
    includeStopSale() {
      return this.contractData.mc_prod_list.some((mc) => {
        return (
          mc.stop_sale == "1" ||
          mc.sc_prod_list.some((sc) => {
            return sc.stop_sale == "1";
          })
        );
      });
    },
    //是否含無分分證
    includeNoId() {
      return (
        this.contractData.insured_id.indexOf("~") > -1 ||
        this.contractData.insurer_id.indexOf("~") > -1 ||
        this.contractData.mc_prod_list.some((mc) => {
          return mc.sc_prod_list.some((sc) => {
            return sc.insured_id.indexOf("~") > -1;
          });
        })
      );
    },
    is_crm() {
      return this.$store.getters.QueryDetailTarget.is_crm;
    },
    insured_id() {
      return this.$store.getters.QueryDetailTarget.insured_id;
    },
    prod_idx() {
      return this.$store.getters.QueryDetailTarget.prod_idx;
    },
    familyid() {
      return this.$store.getters.QueryDetailTarget.familyid;
    },
  },
  created() {
    if (this.$store.getters.QueryDetailTarget.is_crm == "") {
      return this.$router.replace("/mf/performace");
    }
  },
  methods: {
    moment,
    getTotal_mc(mc) {
      let total = parseInt(mc.premium);
      if (mc.sc_prod_list) {
        mc.sc_prod_list.forEach((item) => (total += parseInt(item.premium)));
      }
      return total;
    },
    //通知父層刪除該筆建議書
    async confirmDelete() {
      this.$emit("update:selected", this.contractData);
      await this.$nextTick();
      this.$emit("delete-proposal", {
        prod_idx: this.contractData.prod_idx,
        prod_type: "1",
      });
    },
    //通知父層該筆建議書動作(列印建議書、匯入行動投保、修改建議書、匯入保單健檢)
    async featuresHandler(mode) {
      this.$emit("update:selected", this.contractData);
      await this.$nextTick();
      
      this.$emit("select-contract-date-handler", this.contractData);
      this.$emit("features-handler", mode);
    },
    async routeToCustDetailWithCustomStatusCheck(custId) {
      this.$emit("update:selected", this.contractData);
      await this.$nextTick();

      this.$emit("select-contract-date-handler", this.contractData);
      if (this.$listeners["route-to-cust-detail"]) {
        this.$emit("route-to-cust-detail", custId);
        return;
      }
      this.routeToCustDetail(custId);
    },
  },
  watch: {
    NO: {
      handler() {
        this.contractData.NO = this.NO;
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.QueryContractItem {
  max-width: 904px;
  width: 100%;
  border-radius: 4px;
  border: solid 2px #53c480;
  &__head {
    background-color: #cceed9;
    border-bottom: solid 2px #53c480;
    padding: 4px 15px;
    display: flex;
    align-items: center;
    font-size: 18px;
    font-weight: 700;
    &__date,
    &__insured {
      white-space: nowrap;
      flex-grow: 0;
    }
  }
  &__mc {
    &__index {
      padding: 15px;
      line-height: 1.38;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-weight: 700;
      color: #027a39;
      background-color: #e5f6ec;
      border-top: solid 1px rgba(194, 196, 199, 0.8);
    }
    &__title {
      width: 100%;
      display: flex;
      font-weight: 700;
      color: #027a39;
      background-color: #e5f6ec;
      border-top: solid 1px rgba(194, 196, 199, 0.8);
      & > div {
        border: solid 1px rgba(194, 196, 199, 0.8);
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        padding: 3px 7px;
      }
      & > div:nth-of-type(1) {
        min-height: 50px;
        width: 38%;
      }
      & > div:nth-of-type(2) {
        width: 6%;
      }
      & > div:nth-of-type(3) {
        width: 6%;
      }
      & > div:nth-of-type(4) {
        width: 14%;
      }
      & > div:nth-of-type(5) {
        width: 15%;
      }
      & > div:nth-of-type(6) {
        width: 15%;
      }
      & > div:nth-of-type(7) {
        width: 6%;
      }
    }
    //主約
    &__info {
      width: 100%;
      display: flex;
      color: #323a45;
      background-color: #fff;
      border-top: solid 1px rgba(194, 196, 199, 0.8);
      & > div {
        border: solid 1px rgba(194, 196, 199, 0.8);
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        padding: 3px 7px;
      }
      & > div:nth-of-type(1) {
        min-height: 50px;
        width: 38%;
      }
      & > div:nth-of-type(2) {
        width: 6%;
      }
      & > div:nth-of-type(3) {
        width: 6%;
      }
      & > div:nth-of-type(4) {
        width: 14%;
      }
      & > div:nth-of-type(5) {
        width: 15%;
      }
      & > div:nth-of-type(6) {
        width: 15%;
      }
      & > div:nth-of-type(7) {
        width: 6%;
        &.stop_sale {
          color: #000;
          font-weight: 700;
        }
      }
    }
    //   附約
    &__SC {
      width: 100%;
      display: flex;
      color: #323a45;
      background-color: #f5f5f5;
      border-top: solid 1px rgba(194, 196, 199, 0.8);
      & > div {
        border: solid 1px rgba(194, 196, 199, 0.8);
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        padding: 3px 7px;
      }
      & > div:nth-of-type(1) {
        min-height: 50px;
        width: 38%;
      }
      & > div:nth-of-type(2) {
        width: 6%;
      }
      & > div:nth-of-type(3) {
        width: 6%;
      }
      & > div:nth-of-type(4) {
        width: 14%;
      }
      & > div:nth-of-type(5) {
        width: 15%;
      }
      & > div:nth-of-type(6) {
        width: 15%;
      }
      & > div:nth-of-type(7) {
        width: 6%;
        &.stop_sale {
          color: #000;
          font-weight: 700;
        }
      }
    }
  }

  //   應繳保費合計(折減前)
  &__totalBeforeDiscount {
    padding: 10px;
    line-height: 1.38;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: 700;
    color: #323a45;
    background-color: #fff3c2;
    border: solid 1px rgba(194, 196, 199, 0.8);
  }

  .btn-md {
    padding: 5px 5px;
    font-size: 17px;
  }
  .QueryContractItem__head {
    padding: 4px 7px;
  }
}
.QueryContractItem__head__insured /deep/ .tooltip .tooltip-text,
.QueryContractItem__head__insured /deep/ .tooltip .tooltip-text strong {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 16px;
  font-weight: 400;
}
</style>
